/**
 * Updates sticky menu items
 * @param {nodelist} menuItems 
 * @param {nodelist} sections 
 */
export const updateMenu = (menu, sections, countMargins = false) => {
	const header = document.querySelector('[data-ref="header"]');
	const headerRect = header.getBoundingClientRect();
	const headerHeight = headerRect.height;
	const tolerance = 0;

	const sectionData = [...sections].map(section => {
		let rect = section.getBoundingClientRect();
		let sectionTop = rect.top - headerHeight,
			sectionBottom = rect.bottom - headerHeight;

		if (countMargins) {
			// margin heights
			let sectionStyle = getComputedStyle(section);
			sectionTop += parseInt(sectionStyle.marginTop);
			sectionBottom += parseInt(sectionStyle.marginBottom);
		}

		let color = section.dataset.color,
			id = section.getAttribute('id');
		
		if (sectionTop < 0 && sectionBottom > 0) {
			if (color && color === 'black') {
				menu.classList.add('u-text--light-grey');
			} else {
				menu.classList.remove('u-text--light-grey');
			}
			menu.querySelector(`a[href="#${id}"]`).classList.add('active');
		} else {
			menu.querySelector(`a[href="#${id}"]`).classList.remove('active');
		}
		return {active: sectionTop < tolerance && sectionBottom > tolerance, color, id};
	});
}

// https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_throttle
/**
 * Throttles given function
 * @param {Number} delay 
 * @param {Function} func 
 * @returns Function
 */
export function throttled(delay, func) {
	var lastTime = 0;
	return function () {
		var now = new Date();
		if (now - lastTime >= delay) {
			func();
			lastTime = now;
		}
	};
}

/**
 * Debounce function
 * @param {Object} callback 
 * @param {Number} wait 
 * @returns 
 */
 export function debounce(callback, wait) {
    let timeout;
    return (args) => {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => callback.apply(context, args), wait);
    };
}